import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule, MatListModule, MatCardModule, MatSidenavModule,
   MatAutocompleteModule, MatInputModule, MatSelectModule, MatDatepickerModule,
  MatNativeDateModule, MatMenuModule, MatPaginatorModule, MatTableModule, MatExpansionModule, MatDialogModule,
  MatProgressSpinnerModule, MatRadioModule, MatSnackBarModule, MatTooltipModule, MatStepperModule, MatDialogRef, MAT_DIALOG_DATA,  MatPaginatorIntl, MatIconModule } from '@angular/material';
 

import { HomeComponent } from './home/home.component';

import { AppRoutingModule, routingComponents } from './app-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpUtilService } from './services/http-util.service';
import { TopoComponent } from './topo/topo.component';
import { NgxMaskModule } from 'ngx-mask';
import { NgBrazil } from 'ng-brazil';
import { TextMaskModule } from 'angular2-text-mask';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import {Ng2BRPipesModule} from 'ng2-brpipes';
import { GenericModalComponent } from './generic-modal/generic-modal.component';
import { ModalAjudaAtivacaoKriptonitaComponent } from './modal-ajuda-ativacao-kriptonita/modal-ajuda-ativacao-kriptonita.component';
import { RodapeComponent } from './rodape/rodape.component';
import { NomeSistemaComponent } from './nome-sistema/nome-sistema.component';
import { AcessoComRegistroComponent } from './acesso-com-registro/acesso-com-registro.component';
import { NovoRegistroComponent } from './novo-registro/novo-registro.component';
import { ModalContratoComponent } from './modal-contrato/modal-contrato.component';
import { ContratoAmploComponent  } from './contratos/contrato-amplo.component';
import { ContratoAmploPfComponent } from './contratos/contrato-amplo-pf.component';
import { ModalMensagemComponent } from './modal-mensagem/modal-mensagem.component';

import { AcessoNegadoComponent } from './acesso-negado/acesso-negado.component';
import { RegistroSucessoComponent } from './sucesso/registro-sucesso.component';
import { RenovarRegistroComponent } from './renovar-registro/renovar-registro.component';
import { ListaServicosComponent } from './lista-servicos/lista-servicos.component';
import { SelecionaPerfilComponent } from './seleciona-perfil/seleciona-perfil.component';
import { RenovaContratoAmploPfComponent } from './renova-contrato-amplo-pf/renova-contrato-amplo-pf.component';
import { RenovaContratoAmploPjComponent } from './renova-contrato-amplo-pj/renova-contrato-amplo-pj.component';
import { PaginaNaoEncontradaComponent } from './pagina-nao-encontrada/pagina-nao-encontrada.component';
import { SistemaCarregandoComponent } from './sistema-carregando/sistema-carregando.component';
import { LoadService } from './services/load.service';
import { LoaderInterceptorService } from './interceptors/loader-interceptor.service';
import { BotaoAjudaComponent } from './botao-ajuda/botao-ajuda.component';
import { ModalCnsBasicoComponent } from './modal-cns-basico/modal-cns-basico.component';
import { CnsController } from './cns-controller';
import { ModalCryptoComponent } from './modal-Crypto/modal-crypto.component';


@NgModule({

  declarations: [
    AppComponent,
    routingComponents,
    HomeComponent,
    TopoComponent,
    GenericModalComponent,
    ModalAjudaAtivacaoKriptonitaComponent,
    RodapeComponent,
    NomeSistemaComponent,
    AcessoComRegistroComponent,
    AcessoNegadoComponent,
    CnsController,
    NovoRegistroComponent,
    ModalContratoComponent, 
    ModalMensagemComponent,
    ContratoAmploComponent,
    ContratoAmploPfComponent,
    RegistroSucessoComponent,
    RenovarRegistroComponent,
    ListaServicosComponent,
    SelecionaPerfilComponent,
    RenovaContratoAmploPfComponent,
    RenovaContratoAmploPjComponent,
    PaginaNaoEncontradaComponent,
    SistemaCarregandoComponent,
    BotaoAjudaComponent,
    ModalCnsBasicoComponent,
    ModalCryptoComponent
  ],
  
  entryComponents: [ModalCnsBasicoComponent, GenericModalComponent, ModalCryptoComponent, ModalMensagemComponent, ModalContratoComponent, ModalAjudaAtivacaoKriptonitaComponent],
  
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    AppRoutingModule,
    NgxMaskModule.forRoot(),
    MatListModule,
    MatCardModule,
    MatRadioModule,
    MatSidenavModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    MatTableModule,
    MatExpansionModule,
    TextMaskModule,
    NgBrazil,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
    MatListModule,
    MatTooltipModule,
    Ng2BRPipesModule,
    MatStepperModule
   
  ],
  exports: [Ng2BRPipesModule],
  providers: [
    HttpUtilService,
 
  { provide: LOCALE_ID, useValue: 'pt-PT'},
  { provide: LocationStrategy, useClass: HashLocationStrategy },
  { provide: MAT_DIALOG_DATA, useValue: {} },
  { provide: MatDialogRef, useValue: {} },
  LoadService,
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
